module.exports = __webpack_public_path__ + "135562f4fb386972eac76a21d9fe01e9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-12.png
// module id = 2174
// module chunks = 0